import React from 'react';
import { useNavigate } from 'react-router-dom';
import Register from '../components/Auth/Register';

function RegisterPage() {
  const navigate = useNavigate();

  const handleSwitchToLogin = () => {
    navigate('/login');
  };

  const handleRegisterSuccess = () => {
    navigate('/demo?checkout=free');
  };

  return (
    <div>
      <Register 
        onSwitchToLogin={handleSwitchToLogin}
        onRegisterSuccess={handleRegisterSuccess}
      />
    </div>
  );
}
//ok
export default RegisterPage;